import { Constructor } from '@skylab-shared/types';

import 'reflect-metadata';

import { Domain, ModelBase } from './../../model';

import { BusinessObjectBase, BusinessObjectConfig, InternalBusinessObjectConfig } from './business-object-base';

declare type BoConstructor<TModel extends ModelBase> = Constructor<BusinessObjectBase<TModel>>;
declare type BoDecorator<TModel extends ModelBase> = (target: BoConstructor<TModel>) => void;

export function BO<TModel extends ModelBase>(config: BusinessObjectConfig<TModel>): BoDecorator<TModel> {
    return target => {
        if (config.mixins?.length) applyMixins(target, config.mixins);

        const domain = Domain.determineDomain(config.modelType);
        Reflect.defineMetadata('skl:bo', <InternalBusinessObjectConfig<TModel>>{
            domain,
            ...config
        }, target);
    };
}

function applyMixins(baseConstructor: BoConstructor<ModelBase>, mixins: typeof BusinessObjectBase<ModelBase>[]) {
    mixins.forEach(mixin => {
        Object.getOwnPropertyNames(mixin.prototype).forEach(name => {
            if (name === 'constructor') return;
            Object.defineProperty(
                baseConstructor.prototype,
                name,
                Object.getOwnPropertyDescriptor(mixin.prototype, name)!
            );
        });
    });
}
